<template>
  <div
    class="widget mt-3"
    :class="{'widget--active': mouseIn}"
    @mouseenter="mouseEnter()"
    @mouseleave="mouseExit()"
  >
    <div>
      <!-- <div class="widget__actions" :class="{'widget__actions--visible': mouseIn}" >

      </div>-->
      <base-heading
        class="text-capitalize widget__title__container"
        :style="`${disabled ? '' : 'cursor: grab'}`"
      >
        <span
          class="widget__title"
          :class="{'widget__title--active': mouseIn}"
        >{{ title }}</span>
      </base-heading>
      <base-icon
        class="widget__button__delete"
        :class="{'widget__button__delete--visible': mouseIn}"
        icon="widget-close"
        @click="deleteBlock()"
      />
      <pre v-if="debug">{{ content }}</pre>

      <!-- Loading -->
      <div v-if="status === 'loading'">
        <base-loading />
      </div>

      <!-- Error -->
      <div v-if="status === 'error'">
        <div class="bg-white text-center p-5">
          <div class="border border-dark px-3 py-2 d-inline-block">
            <font-awesome-icon icon="eye-slash" />Section preview is not available
            <div v-if="debug">
              <a
                href="#"
                @click.prevent="loadContent"
              >Try again?</a>
            </div>
          </div>
        </div>
      </div>

      <!-- Done -->
      <div v-if="status === 'done'">
        <template v-if="block.type == 'text-widget'">
          <component
            :is="block.type"
            v-if="block"
            :key="url"
            ref="component"
            :value="content.text"
            :dropped="block.dropped"
            @input="contentUpdate"
            @open="block.dropped = false"
          />
        </template>
        <template v-else>
          <component
            :is="block.type"
            v-if="block"
            ref="component"
            :key="url"
            :content="content"
            v-bind="{ editSectionId: widget.id }"
            :dropped="block.dropped"
            @contentUpdated="contentUpdate"
            @open="block.dropped = false"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import PasteImageMixin from '../_utilities/PasteImageMixin';

export default {
  name: 'BlockWidget',
  mixins: [PasteImageMixin],
  props: {
    index: {
      type: Number,
    },
    url: {
      type: String,
    },
    widget: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      debug: false,
      mouseIn: false,
      keyListener: null,
      saving: false,
    };
  },
  computed: {
    block() {
      return this.$store.getters['sections/getItemByURL'](this.url);
    },
    status() {
      /*
      console.log(
        'Log: Status',
        this.$store.getters['sections/getStatusByURL'](this.url),
        this.url,
      );
      */
      return this.$store.getters['sections/getStatusByURL'](this.url);
    },
    content: {
      get() {
        if (!this.block) {
          return null;
        }
        switch (this.block.type) {
          case 'text-widget':
            return {
              text: this.block.text_content,
            };

          case 'image-widget':
            return {
              canvas: this.block.canvas_content,
              svg_image: this.block.svg_image,
              map: this.block.map_content,
              options: this.block.options,
              png_render: this.block.png_render,
              collage_width: this.block.collage_width,
              collage_height: this.block.collage_height,
            };

          case 'product-widget':
            return {
              product_images: this.block.product_images || [],
              product_row_width: this.block.product_row_width,
            };

          default:
            console.log('Block type not defined', this.block.type);
            return {};
        }
      },
      // eslint-disable-next-line
      set(value) {
        // const val = null;
        switch (this.block.type) {
          case 'text-widget':
            this.block.text_content = value;
            break;

          case 'image-widget':
            this.block.canvas_content = JSON.stringify(value.canvas);
            this.block.svg_image = value.image;
            this.block.map_content = JSON.stringify(value.map);
            this.block.options = value.options;
            this.block.png_render = value.png_render;
            this.block.copy = value.copy;
            break;

          case 'product-widget':
            this.block.product_images = value.product_images;
            this.block.product_row_width = value.product_row_width;
            break;

          default:
            console.log('Block type not defined', this.block.type);
            return {};
        }

        this.saveContent();
        // this.$emit('componenUpdated', this, val)
      },
    },
  },
  watch: {
    url: {
      immediate: true,
      handler() {
        this.loadContent();
      },
    },
  },
  methods: {
    saveContent: _.debounce(function () {
      /*
        IMPORTANT: the way periodic saving is achieved via the set() setter
                   of the computed 'content' prop, and the contentUpdate()
                   method that gets passed down to sub-components!
       */
      console.log('Trying to saveContent() on a ongoing basis.', this.url);
      this.saving = true;
      this.$emit('savingchange', this.index);
      this.widget.product_row_width = this.block.product_row_width;
      this.$store.dispatch('sections/patchItem', this.url).then(() => {
        this.saving = false;
        this.$emit('savingchange', this.index);
      });
    }, 200),
    loadContent() {
      // Fetch item
      this.$store.dispatch('sections/fetchItem', this.url).then(() => {});
    },
    contentUpdate(payload) {
      this.content = payload;
    },
    deleteBlock() {
      this.$emit('deleteBlock', this.index);
    },
    mouseEnter() {
      console.log('=----');
      this.mouseIn = true;
      // this.activatePaste()
    },
    mouseExit() {
      this.mouseIn = false;
      // this.deactivatePaste()
    },
  },
};
</script>
<style lang="scss">
.widget {
  position: relative;
  // border-top: solid 1px transparent;
  // border-bottom: solid 1px transparent;
  // transition: border 0.5s;
  // background-color: #f7f7f7;
  // background-color: $bg-edits;

  &__title__container {
    overflow: hidden;
    position: relative;
  }
  &__title {
    position: relative;
    &:after {
      //width: 0;
      opacity: 0;
      content: "";
      border-bottom: solid 1px black;
      height: 1px;
      display: block;
      transition: 0.2s all;
      width: 1000px;
      left: calc(100% + 10px);
      top: 50%;
      position: absolute;
      @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
      opacity: 1;
    }
    }
    &--active:after {
      opacity: 1;
    }
  }

  &::before {
    content: "";
    border-top: solid 1px black;
    left: 40px;
    right: 40px;
    position: absolute;
    opacity: 0;
    transition: all 0.3s;
  }

  // border-bottom: dotted 1px $primary;

  &--active {
    // background-color: rgba(black, 0.1);
    &::before {
      //left: 20px;
      //right: 20px;
      //opacity: 1;
    }
  }
  &__container {
    max-width: 1114px;
    margin: 0 auto;
    padding: 1rem 0;
  }
  &__actions {
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 0;
    transition: all 0.5s;
    border-radius: 3px;
    &--visible {
      opacity: 1;
    }
  }
  &__button {
    color: white;
    background: none;
    border: none;
    padding: 1rem;
    cursor: pointer;
  }
  &__button__delete {
    position: absolute;
    right: -1px;
    top: 0px;
    opacity: 0;
    transition: opacity 0.2s ease;
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
      opacity: 1;
    }
    &--visible {
      opacity: 1;
    }
  }
}
</style>
